import React, { useEffect, useState } from "react";
import CommonDivWidget from "components/CommonDivWidget/CommonDivWidget";
import { message, Spin, Row, Col } from "antd";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";
import TableWidget from "./TableWidget/TableWidget";
import { showAddPriceTierDialog } from "./AddPriceTierDialog/showAddPriceTierDialog";
import {
  apiGetPriceTierList,
  apiCreatePriceTier,
  apiUpdatePriceTier,
  apiDeletePriceTier,
} from "services/shopBuyerService";

function ShopPriceTierListPage() {
  const [isBusy, setIsBusy] = useState(false);
  const [dataList, setDataList] = useState([]);

  const loadTiers = () => {
    setIsBusy(true);
    apiGetPriceTierList()
      .then((data) => {
        setIsBusy(false);
        setDataList(data || []);
      })
      .catch((err) => {
        setIsBusy(false);
        setDataList([]);
        message.error("Sorry! " + err);
      });
  };

  useEffect(() => {
    loadTiers();
  }, []);

  const onNewTier = async () => {
    var res = await showAddPriceTierDialog({ title: "New Price Tier", isEditing: false });
    if (res === null) return;
    setIsBusy(true);
    apiCreatePriceTier(res)
      .then((data) => {
        setIsBusy(false);
        setDataList([...dataList, data]);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error("Error! " + err);
      });
  };

  const onClickEdit = async (pInfo) => {
    var res = await showAddPriceTierDialog({ title: "Edit Price Tier", record: pInfo, isEditing: true });
    if (res === null) return;
    setIsBusy(true);
    apiUpdatePriceTier(res)
      .then((data) => {
        setIsBusy(false);
        let updateData = [...dataList];
        var idx = updateData.findIndex((x) => x.id == data.id);
        updateData.splice(idx, 1, data);
        setDataList(updateData);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  const onClickDelete = (pInfo) => {
    setIsBusy(true);
    apiDeletePriceTier(pInfo.id)
      .then(() => {
        setIsBusy(false);
        setDataList(dataList.filter((x) => x.id != pInfo.id));
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  return (
    <CommonDivWidget>
      <Spin spinning={isBusy}>
        <h1>Wholesale Price Tiers</h1>
        <Row>
          <Col flex={"auto"} />
          <Col>
            <div style={{ fontFamily: "mediumFont", padding: 20 }}>
              <CommonButton onClick={onNewTier}>New</CommonButton>
            </div>
          </Col>
        </Row>

        <div style={{ paddingTop: 16 }}>
          <TableWidget dataList={dataList} onUpdateAction={onClickEdit} onDeleteAction={onClickDelete} />
        </div>
      </Spin>
    </CommonDivWidget>
  );
}

export default ShopPriceTierListPage;
